import React, { useEffect, useRef, useState } from "react";
import {
   endpointRequest,
   updateServerSession,
} from "../../../../utilities/requests";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import "./ECLPivotTable.css";
import ECLTable from "../../../Widgets/ECLTable/ECLTable";
import ECLLoader from "../../../Widgets/ECLLoader/ECLLoader";
import Sortable from "sortablejs";
import PivotTableSettings from "./components/PivotTableSettings";
import ECLBlockOptions from "../../components/ECLBlockOptions";

export default function ECLPivotTable(props) {
   const instanceId = useSelectorId();
   const [table, setTable] = useState(null);
   const [pivotSettings, setPivotSettings] = useState(null);
   const [tableBoxHeight, setTableBoxHeight] = useState(300);
   const sortableRowsRef = useRef(null);
   const sortableColumnsRef = useRef(null);

   const rootID = props.headlist.at(-1); //Last item on the headlist is your root
   const sessionID = props.flatDoc[rootID].session;

   useEffect(() => {
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionID,
         "AllData",
      ).then((res) => {
         setTable({
            columns: res.columns,
            rows: res.rows.map((r) => {
               return { row: r };
            }),
         });
      });
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionID,
         "metadata",
      ).then((res) => {
         //Init pivot settings using metadata and block data
         setPivotSettings({
            dimensions: res.rows
               .filter((c) => c[1] === "dimension")
               .map((c) => c[0]),
            measures: res.rows
               .filter((c) => c[1] === "measure")
               .map((c) => c[0]),
            activeRows: props.block.data.rows,
            activeColumns: props.block.data.columns,
            activeMeasures: props.block.data.measures,
         });
      });
   }, []);

   useEffect(() => {
      if (pivotSettings && table) {
         endpointRequest(
            props.parentObject,
            props.block.id,
            sessionID,
            "AllData",
         ).then((res) => {
            setTable({
               columns: res.columns,
               rows: res.rows.map((r) => {
                  return { row: r };
               }),
            });
         });
      }
   }, [props.block.react.refresh]);

   useEffect(() => {
      if (pivotSettings && table) {
         updateServerSession(props, [
            {
               key: "config",
               value: {
                  rows: pivotSettings.activeRows,
                  columns: pivotSettings.activeColumns,
                  measures: pivotSettings.activeMeasures,
               },
            },
         ]);
      }

      if (sortableRowsRef.current) {
         sortableRowsRef.current.destroy();
      }
      if (sortableColumnsRef.current) {
         sortableColumnsRef.current.destroy();
      }

      const rowsContainer = document.querySelector(".sortable-rows-container");
      if (rowsContainer) {
         sortableRowsRef.current = Sortable.create(rowsContainer, {
            onEnd: (evt) => {
               let newRows = [];
               evt.target.childNodes.forEach((n) => {
                  newRows.push(n.innerText);
               });
               setPivotSettings({
                  ...pivotSettings,
                  activeRows: newRows,
               });
            },
         });
      }
      const columnsContainer = document.querySelector(
         ".sortable-columns-container",
      );
      if (columnsContainer) {
         sortableColumnsRef.current = Sortable.create(columnsContainer, {
            onEnd: (evt) => {
               let newColumns = [];
               evt.target.childNodes.forEach((n) => {
                  newColumns.push(n.innerText);
               });
               setPivotSettings({
                  ...pivotSettings,
                  activeColumns: newColumns,
               });
            },
         });
      }
   }, [pivotSettings]);

   //Since the settings box starts open, these functions can
   function toggleSettingsBox(open) {
      const settingsBox = document.querySelector(".pivot-table-settings-box");
      const settingsCombos = document.querySelectorAll(
         ".pivot-table-settings-combo",
      );
      if (!open) {
         setTableBoxHeight(540);
         //check for screen size to determine which class should have overflow hidden
         if (
            (window.innerWidth < 769 &&
               screen.orientation.type.includes("portrait")) ||
            (window.innerHeight < 769 &&
               screen.orientation.type.includes("landscape"))
         ) {
            settingsBox.style.overflow = "hidden";
            settingsCombos.forEach((c) => {
               c.style.opacity = 0;
            });
         } else {
            settingsCombos.forEach((c) => {
               c.style.overflow = "hidden";
               c.style.opacity = 0;
            });
         }
      } else {
         setTableBoxHeight(300);
         setTimeout(() => {
            document.querySelector(".pivot-table-settings-box").style.overflow =
               "auto";
         }, 500);
         setTimeout(() => {
            settingsCombos.forEach((c) => (c.style.overflow = "auto"));
         }, 500);
         settingsCombos.forEach((c) => {
            c.style.opacity = 1;
         });
      }
   }

   if (!table || !pivotSettings) return <ECLLoader />;

   return (
      <div
         className={"pivot-table-block-container"}
         id={"table-block" + instanceId}
      >
         <ECLBlockOptions
            block={props.block}
            instanceId={instanceId}
            settingsWidget={
               <PivotTableSettings
                  pivotSettings={pivotSettings}
                  setPivotSettings={setPivotSettings}
               />
            }
            settingsWidgetHeight={240}
            settingsWidgetInit={true}
            settingsWidgetCallback={toggleSettingsBox}
            expandWidget={
               <ECLTable
                  rowData={table.rows}
                  columnSettings={table.columns.map((c) => {
                     return {
                        label: c.name,
                        id: c.name,
                     };
                  })}
                  tableSettings={{
                     columnOrder: table.columns.map((c) => c.name),
                     rowHeight: 35,
                  }}
               />
            }
         />
         <div className="pivot-table-block-content-box">
            <div
               id={"table-block-table" + instanceId}
               className="ecl-table-block-container"
               style={{ width: "100%", height: tableBoxHeight + "px" }}
            >
               <ECLTable
                  rowData={table.rows}
                  columnSettings={table.columns.map((c) => {
                     return {
                        label: c.name,
                        id: c.name,
                     };
                  })}
                  tableSettings={{
                     columnOrder: table.columns.map((c) => c.name),
                     rowHeight: 35,
                  }}
               />
            </div>
         </div>
      </div>
   );
}
